import { Application, Fulfillment } from '@bybeam/platform-types';

export default function findFulfillmentApplication(
  applications: Application[],
  fulfillmentId: string,
): { fulfillment: Fulfillment; application: Application } {
  const flatApps = applications.flatMap((application) => {
    return application.case?.fulfillments?.map((fulfillment) => ({
      fulfillment,
      application,
    }));
  });
  const lookup = flatApps.find(({ fulfillment }) => fulfillment.id === fulfillmentId);
  return {
    fulfillment: lookup?.fulfillment,
    application: lookup?.application,
  };
}
